function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFacilityPetsFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.366 17.676l-3.18-1.704a.997.997 0 00-1.316.345l-.11.173-3.072-3.554 3.019-3.73 1.067-1.413.616-.348.129 3.26a.999.999 0 00.438.788l4.314 2.93-1.905 3.253zm-7.947 7.974l-.646-4.305a1 1 0 00-.99-.851H9.597a1 1 0 00-.98.804l-.87 4.352h-2.51l.462-8.744a1.004 1.004 0 00-.157-.592c-.346-.543-1.037-1.91-1.134-3.105l.855.947a.994.994 0 00.686.329l9.522.53c.32.016.63-.118.833-.368l.107-.131 3.228 3.736-.573.9c-.13.203-.18.446-.145.684l.86 5.814H17.42zm11.75-12.356l-4.671-3.172-.174-4.394a1.002 1.002 0 00-1.491-.831l-2.224 1.257a.992.992 0 00-.305.268l-1.172 1.552-4.061 5.017-8.601-.481-1.802-1.998a1 1 0 00-1.542.07c-1.685 2.246-.041 5.498.558 6.527l-.5 9.488a1.001 1.001 0 00.999 1.053h4.382a1 1 0 00.98-.804l.87-4.352h4.508l.645 4.305a1 1 0 00.989.85h4.383a.997.997 0 00.989-1.146l-.976-6.592 1.106-1.738 3.21 1.72a1 1 0 001.336-.375l2.865-4.891a1.001 1.001 0 00-.301-1.333z",
    fill: props.color
  }));
}

export default SvgIconFacilityPetsFilled;